var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-row-view',{attrs:{"data-list":_vm.tableData,"setting":_vm.setting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }